var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "container_3" },
    [
      _vm.value.contactUserName
        ? _c("div", { staticClass: "contact_1 hover-shadow" }, [
            _c("span", [
              _vm._v(
                _vm._s(_vm.value.contactUserName) +
                  "(" +
                  _vm._s(_vm.value.contactUserPhone) +
                  ")"
              )
            ]),
            _vm._v(" "),
            _c("i", {
              staticClass: "el-icon-arrow-down",
              staticStyle: { float: "right", "padding-top": "10px" },
              on: { click: _vm.onClick }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.value.contactUserName
        ? _c("div", { staticClass: "contact_1 hover-shadow" }, [
            _c("span", { staticStyle: { color: "#c7c7c7" } }, [
              _vm._v("工单联系人")
            ]),
            _vm._v(" "),
            _c("i", {
              staticClass: "el-icon-arrow-down",
              staticStyle: {
                float: "right",
                "padding-top": "10px",
                cursor: "pointer"
              },
              on: { click: _vm.onClick }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "dialog_1",
          attrs: {
            title: "修改联系人",
            top: "0",
            modal: false,
            visible: _vm.dialogVisible,
            width: "600px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { staticStyle: { padding: "0 15px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "姓名" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.contactUserName,
                      callback: function($$v) {
                        _vm.contactUserName = $$v
                      },
                      expression: "contactUserName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "联系方式" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.contactUserPhone,
                      callback: function($$v) {
                        _vm.contactUserPhone = $$v
                      },
                      expression: "contactUserPhone"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f21930c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f21930c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketContactUser.vue
// module id = 832
// module chunks = 75